//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Footer from '../footer/footer.vue'
import Header from '../header/header.vue'
import Multiselect from "vue-multiselect";
import { areaData } from "../../util/areaDataNew";
import {requestByPost} from '@/util/request'
import {API} from '@/util/api'
import { Toast} from 'vant';
import { toolRex } from '@/util/base';
import demandAddForm from '../modules/demandAddForm'
import supplyDemandAddForm from '../modules/supplyDemandAddForm'
import quoLoginModule from "@/pages/product/quoLoginModule"
export default {
 name: 'demand',
 data(){
  return {
    selType: (this.$route.query.selType != null && this.$route.query.selType != '' ) ? this.$route.query.selType : 1,//查询数据类型 1查询需求  2查询服务商
    toolRexs:toolRex,//正则校验
    checkProvinceId: null, // 选中的省id
    checkCityId: null, // 选中的 市id
    checkAreaId: null, // 选中的 区id
    userInfo: this.$store.getters.getUserInfo,
    startBudgetMoney: null,//金额范围 开始金额
    endBudgetMoney: null,//金额范围 结束金额
    sortType:1,//排序方式
    sortSupplyType:1,
    province: null, // 省
    city: null, // 市
    area: null, // 区
    provinceData: areaData, // 省下拉列表
    cityData: [], // 市下拉列表
    areaData: [], // 区下拉列表
    pageSizeSel: 12, //首页各项默认显示几条
    societyId: (this.$route.query.societyId != null && this.$route.query.societyId != '' ) ? this.$route.query.societyId : window.localStorage.getItem('societyId'),//0显示平台头部按钮  1显示机构头部按钮,  //机构id
    societyName: (this.$route.query.societyName != null && this.$route.query.societyName != '' ) ? this.$route.query.societyName : window.localStorage.getItem('societyName'),
    checkDemandTypeId: "-1",//当前选中的需求分类id
    selObj: {},
    loadDemandName: "加载更多",//底部加载更多按钮名称
    canSelDemand: true,//是否还能点击加载更多需求或服务商  true可以，false已经全显示完了
    userDemandList: null, //客户需求list
    supplyDemandList: null,//服务商list

    demandTypeList: null, // 客户需求类型 list
    supplyDemandTypeList: null //服务商类型list

  }
 },
 components:{
    Header,
    Footer,
    Multiselect,
    demandAddForm,
    supplyDemandAddForm,
    quoLoginModule
 },
 computed:{
      text () {
        return {

        }
      },
 },
 activated () {
    this.userInfo = this.$store.getters.getUserInfo
  },
  methods:{
      checkMoneyFw(type){
        let that = this;
        if(type == 1 && that.startBudgetMoney != null && that.startBudgetMoney != ""){
          var r = that.startBudgetMoney.match(that.toolRexs.numberRex);
          if(r==null){
              that.startBudgetMoney = null;
              Toast('对不起，您输入的格式不正确,请输入整数或保留2位小数');
          }
          if (type.length > 7) {
            that.startBudgetMoney = that.startBudgetMoney.substring(0, 8)
          }
        }else if(type == 2 && that.endBudgetMoney != null && that.endBudgetMoney != ""){
          var r = that.endBudgetMoney.match(that.toolRexs.numberRex);
          if(r==null){
              that.endBudgetMoney = null;
              Toast('对不起，您输入的格式不正确,请输入整数或保留2位小数');
          }
          if (type.length > 7) {
            that.endBudgetMoney = that.endBudgetMoney.substring(0, 8)
          }
        }
      },
      fnInitData(){
          this.fnInitDemandType();
          this.fnLoadReleaseProdCase(2);
          this.fnInitsupplyDemandType();
      },
      //选择省份后处理城市
      fnHandleCity() {
        if(this.province != null){
          //选择的省份id
          this.checkProvinceId = this.province.id;
          this.cityData = this.province.items;
        }else{
          //选择的省份id
          this.checkProvinceId = null;
          this.cityData = [];
        }
        this.checkCityId = null; // 选中的 市id
        this.checkAreaId = null; // 选中的 区id
        this.areaData = [];
        this.city = null;
        this.area = null;
        this.fnLoadReleaseProdCase(2);
    },
     // 选择城市后处理地区
    fnHandleArea() {
      if(this.city != null){
         //选择的市id
        this.checkCityId = this.city.id;
        this.areaData = this.city.items;
      }else{
        //选择的市id
        this.checkCityId = null;
        this.areaData = [];
      }
      this.area = null;
      this.checkAreaId = null; // 选中的 区id
      this.fnLoadReleaseProdCase(2);
    },
    // 选择区后，处理逻辑
    fnHandleLast() {
      if(this.area != null){
        //选择的区id
        this.checkAreaId = this.area.id;
      }else{
        //选择的区id
        this.checkAreaId = null;
      }
      this.fnLoadReleaseProdCase(2);
    },
    //初始化分类
    fnInitDemandType(){
      let that = this;
      let obj = new Object();
      requestByPost(API.selAllUserDemandType,JSON.stringify(obj)).then((res)=>{
        if(res.data.objs != null && res.data.objs.length != 0){
          that.demandTypeList = res.data.objs;
        }
      })
    },
    fnInitsupplyDemandType () {
      let that = this;
      let obj = new Object();
      requestByPost(API.selAllSupplyDemandType,JSON.stringify(obj)).then((res)=>{
        if(res.data.objs != null && res.data.objs.length != 0){
          that.supplyDemandTypeList = res.data.objs;
        }
      })
    },
    /* 加载更多客户需求数据*/
    fnLoadReleaseProdCase(inType){
      let that = this;
      if(inType == 2){
        that.canSelDemand = true;
        if(that.startBudgetMoney != null && that.startBudgetMoney != "" && that.endBudgetMoney != null  && that.endBudgetMoney != ""){
          if(Number(that.startBudgetMoney) > Number(that.endBudgetMoney)){
            Toast("开始金额不能大于结束金额");
            return;
            // startBudgetMoney = 0;
          }
        }
      }
      if(that.canSelDemand){//说明还有更多的产品信息
         if(inType == 1){//分页查询
          let page = that.selObj.page;
          page.pageNum = Number(page.pageNum)+1;
          that.selObj.page = page;
        }else{
          that.userDemandList = [];
          let page = new Object();
          page.pageNum = 0;
          page.pageSize = that.pageSizeSel;
          that.selObj.page = page;
          that.selObj.demandType = that.checkDemandTypeId;
          that.selObj.provinceCode = that.checkProvinceId;
          if(that.checkProvinceId != null && that.checkProvinceId != "" && that.checkProvinceId != "-1"){
            that.selObj.cityCode = that.checkCityId;
            if(that.checkCityId != null && that.checkCityId != "" && that.checkCityId != "-1"){
              that.selObj.areaCode = that.checkAreaId;
            }else{
              that.selObj.areaCode = null;
            }
          }else{
             that.selObj.cityCode = null;
              that.selObj.areaCode = null;
          }
          that.selObj.startBudgetMoney = that.startBudgetMoney;
          that.selObj.endBudgetMoney = that.endBudgetMoney;
          if (this.selType == 1) {
            that.selObj.sortType = that.sortType;
          }else{
            that.selObj.sortType = that.sortSupplyType;
          }
        }
        if(that.societyId != null && that.societyId != undefined && that.societyId != "" && that.societyId != "-1"){
          that.selObj.societyId = that.societyId;
        }
        if (this.selType == 1) {
          requestByPost(API.selUserDemandPageForHome,JSON.stringify(that.selObj)).then((res)=>{
            if(res.data.obj != null && res.data.obj.userDemandList != null &&  res.data.obj.userDemandList.length != 0){
              that.loadDemandName = "加载更多";
              that.canSelDemand = true;
              let userDemandList = res.data.obj.userDemandList;
              if(inType == 1){//分页查询
                userDemandList.forEach((item, index) => {
                  that.userDemandList.push(item);
                  if(that.userDemandList.length == res.data.obj.page.total){
                    that.canSelDemand = false;
                    that.loadDemandName = "~没有更多了~";
                  }
                })
              }else{
                that.userDemandList = userDemandList;
                if(that.userDemandList.length == res.data.obj.page.total){
                    that.canSelDemand = false;
                    that.loadDemandName = "~没有更多了~";
                  }
              }
            }else{
              if(inType == 2){//
                that.userDemandList = [];
              }
              that.canSelDemand = false;
              that.loadDemandName = "~没有更多了~";
            }
          })
        } else {
          requestByPost(API.selSupplyDemandShowPage,JSON.stringify(that.selObj)).then((res)=>{
            if(res.data.obj != null && res.data.obj.supplyDemandList != null &&  res.data.obj.supplyDemandList.length != 0){
              that.loadDemandName = "加载更多";
              that.canSelDemand = true;
              let supplyDemandList = res.data.obj.supplyDemandList;
              if(inType == 1){//分页查询
                supplyDemandList.forEach((item, index) => {
                  that.supplyDemandList.push(item);
                  if(that.supplyDemandList.length == res.data.obj.page.total){
                    that.canSelDemand = false;
                    that.loadDemandName = "~没有更多了~";
                  }
                })
              }else{
                that.supplyDemandList = supplyDemandList;
                if(that.supplyDemandList.length == res.data.obj.page.total){
                    that.canSelDemand = false;
                    that.loadDemandName = "~没有更多了~";
                  }
              }
            }else{
              if(inType == 2){//
                that.supplyDemandList = [];
              }
              that.canSelDemand = false;
              that.loadDemandName = "~没有更多了~";
            }
          })
        }

      }else{
        //说明该条件下的产品已经全显示出来啦
         Toast('没有更多了')
      }
    },
     // 跳转页面-用户中心  发布需求
    fnGoToPageUcDemand(e){
      this.fnStopBub(e);
      // this.fnGotoUserCenter({self_redirect: '0',second_redirect_uri:'demand',state:'preweb'})
      this.$refs.demandAddForm.showForm(null,this.societyId)
    },
    fnGoToSupplyDemand () {
      if (this.userInfo && this.userInfo.id) {
        //校验该客户拥有的企业有没有所属这个机构的，有就进去，没有则提示
        var list = this.userInfo.ccUserBoList;//公司list
        if (list == null || list.length == 0) {
          Toast("非企业用户，不能发布供应")
        }else {
          let companyList = []
          list.forEach(val =>{
            let societyIdList = val.societyIdList;
            if(societyIdList != null && societyIdList.length > 0 && societyIdList.indexOf(this.societyId) > -1){
              companyList.push(val)
            }
          })
          // setTimeout(() => {

            if(this.societyId != null && this.societyId != '' && companyList.length == 0){
              Toast("非该协会内企业用户，不能在该协会首页发布供应")
            }else{
              this.$refs.supplyDemandAddForm.showForm(this.userInfo,null,this.societyId)
            }
          // }, 1000);

        }
      } else {
        this.$refs.quoLoginModule.showLogin()
      }
      // if (this.userInfo && this.userInfo.id) {
      //   this.$refs.supplyDemandAddForm.showForm(this.userInfo,null,this.societyId)
      // } else {
      //   this.$refs.quoLoginModule.showLogin()
      // }
    },
    //更换需求分类
    fnChangeDemandType(demandTypeId){
      this.checkDemandTypeId = demandTypeId;
      this.fnLoadReleaseProdCase(2);
    },
    fnChangeSupplyDemandType (demandTypeId) {
      this.checkDemandTypeId = demandTypeId;
      this.fnLoadReleaseProdCase(2);
    },
    //更换排序方式
    fnChangeSortType(sortType){
      this.sortType = sortType;
      this.fnLoadReleaseProdCase(2);
    },
    fnChangeSupplySortType (sortType) {
      this.sortSupplyType = sortType
      this.fnLoadReleaseProdCase(2);
    },
    handleUserDemandClicked (e, userDemand) {
      this.fnStopBub(e);
      this.$router.push({path: '/demandDetail', query: {demandId: userDemand.id,inType:2,societyId:this.societyId,societyName: this.societyName}});
    },
    handleSupplyDemandClicked (e, supplyDemand) {
      this.fnStopBub(e);
      // Toast("敬请期待");
      if (supplyDemand.linkType == 0) {
        if(supplyDemand.companyId != null && supplyDemand.companyId  != "" && supplyDemand.companyId  != undefined){
          this.$router.push({path: '/companyDetailNew', query: {companyId: supplyDemand.companyId,inType:0,societyId:this.societyId,societyName: this.societyName}});
        }else{
          Toast("企业未维护主页，无法查看");
        }
      } else if (supplyDemand.linkType == 1) {
        this.$router.push({path: '/caseDetail', query: {projectId: supplyDemand.projectId,inType:0}});
      } else if (supplyDemand.linkType == 2) {
        window.open(supplyDemand.linkStr)
      } else {
        return
      }

    },
    fnChangeSelType (type) {
      this.selType = type
      this.checkProvinceId = null; // 选中的省id
      this.checkCityId = null; // 选中的 市id
      this.checkAreaId = null; // 选中的 区id
      this.startBudgetMoney = null;//金额范围 开始金额
      this.endBudgetMoney = null;//金额范围 结束金额
      this.sortType = 1;//排序方式
      this.sortSupplyType = 1;
      this.province = null; // 省
      this.city = null; // 市
      this.area = null; // 区
      this.checkDemandTypeId = '-1'
      this.fnLoadReleaseProdCase(2);
    },

    handleSaveDemandSuccess () {
      // this.fnLoadReleaseProdCase(2);
      this.fnInitData();
    },
    handleLognSucccess (userInfo) {
      this.$refs.Header.fnSetUserInfo(userInfo)
      this.userInfo = userInfo
    },
    handleLognSucccessDemand (userInfo) {
      this.$refs.Header.fnSetUserInfo(userInfo)
      this.userInfo = userInfo
      this.fnGoToSupplyDemand()
    }
  },
  mounted(){
    document.title = "供需信息"
  },
  created(){
    this.$store.commit('home/setMenuStyle', 3);//为了显示灰色头部背景   2025数字云平台位置
    this.$store.commit('home/setMenuActive', 2);
    // that.selType = (that.$route.query.selType != null && this.$route.query.selType != "" ) ? this.$route.query.selType : 1;
    if (this.$route.query) {
      if (this.$route.query.selType) {
        this.selType = this.$route.query.selType
      }
      if (this.$route.query.demandType) {
        this.checkDemandTypeId = this.$route.query.demandType
      }
    }
    this.fnInitData();
  }
}



// WEBPACK FOOTER //
// ./src/pages/demand/demand.vue